var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoleft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 163.47 38.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:none;}.cls-2{isolation:isolate;}.cls-3{opacity:0.3;mix-blend-mode:soft-light;}.cls-4{clip-path:url(#clip-path);}.cls-5{stroke:#fff;stroke-miterlimit:10;}.cls-6{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-451.28,149.83c15.9,2.6,44.67,2.42,55.67-12.74,7.13-9.83,5.86-21,1.47-31.55-10.4-25.14-23.53-39.63-27.36-68C-428-10.3-382.18-12.82-359.94,23c7.75,12.5,15.62,24.76,22.91,37.52C-305,116.7-238.31,198.85-168.41,161.89c25.85-13.67,41.65-42,37.2-72.53a50.31,50.31,0,0,0-1.65-7.09C-178.16-68.9-57.15-70.62-57.15-70.62H-455.26c.07,0-.06,203.06-.08,219.69C-454,149.36-452.64,149.61-451.28,149.83Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: -221.29,
    y1: -250.07,
    x2: 62.92,
    y2: 34.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: -226.99,
    y1: -245.32,
    x2: 57.22,
    y2: 38.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: -232.69,
    y1: -240.56,
    x2: 51.52,
    y2: 43.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: -238.4,
    y1: -235.8,
    x2: 45.81,
    y2: 48.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: -244.1,
    y1: -231.04,
    x2: 40.11,
    y2: 53.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: -249.8,
    y1: -226.28,
    x2: 34.41,
    y2: 57.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: -255.51,
    y1: -221.53,
    x2: 28.7,
    y2: 62.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: -261.21,
    y1: -216.77,
    x2: 23,
    y2: 67.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: -266.91,
    y1: -212.01,
    x2: 17.3,
    y2: 72.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: -272.62,
    y1: -207.25,
    x2: 11.59,
    y2: 76.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: -278.32,
    y1: -202.5,
    x2: 5.89,
    y2: 81.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: -284.02,
    y1: -197.74,
    x2: 0.19,
    y2: 86.47
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M14.49,19.18a4.9,4.9,0,1,0,4.9-4.9A4.89,4.89,0,0,0,14.49,19.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M36.86,11.77a.12.12,0,0,0-.07-.07.14.14,0,0,0-.11,0l-3.31,2.51a.11.11,0,0,0,0,.13A14.94,14.94,0,1,1,24,5a.11.11,0,0,0,.13,0l2.46-3.33a.14.14,0,0,0,0-.11.1.1,0,0,0-.07-.07A19,19,0,0,0,18.45,0a19.18,19.18,0,0,0,.75,38.34c.29,0,.58,0,.87,0A19.26,19.26,0,0,0,38.34,19.86,19,19,0,0,0,36.86,11.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.39,27.09a7.91,7.91,0,0,1,0-15.82l.57,0a.1.1,0,0,0,.1,0l2.48-3.36a.11.11,0,0,0,0-.11.1.1,0,0,0-.08-.07,11.43,11.43,0,0,0-3.08-.41A11.89,11.89,0,1,0,31.28,19.18a11.77,11.77,0,0,0-.41-3.07A.13.13,0,0,0,30.8,16a.14.14,0,0,0-.11,0l-3.36,2.54a.13.13,0,0,0,0,.11c0,.15,0,.32,0,.48A7.91,7.91,0,0,1,19.39,27.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M23.57,12.14a2.56,2.56,0,1,0,2.56-2.55,2.56,2.56,0,0,0-2.56,2.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M29.94,6.63a1.85,1.85,0,1,0,1.84-1.85,1.84,1.84,0,0,0-1.84,1.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.93,6.88h-6.5a.29.29,0,0,0-.29.29V26a.29.29,0,0,0,.29.29h3.09a.29.29,0,0,0,.29-.29V18.66h3.12c5.13,0,7-3,7-5.88C61.89,9.2,59.16,6.88,54.93,6.88Zm0,8.68H51.81V10h3.12c2.16,0,3.21.92,3.21,2.8S57.06,15.56,54.93,15.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M72.12,10.54a5.23,5.23,0,0,0-4.18,1.8V11.08a.29.29,0,0,0-.29-.29H64.56a.29.29,0,0,0-.29.29V26a.29.29,0,0,0,.29.29h3.09a.29.29,0,0,0,.29-.29V18.15c0-2.72,1-3.83,3.4-3.83h.78a.29.29,0,0,0,.29-.29v-3.2A.29.29,0,0,0,72.12,10.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.39,10.54c-4.63,0-7.74,3.21-7.74,8s3.18,8,7.74,8a7.17,7.17,0,0,0,7.14-4.88.3.3,0,0,0,0-.26.27.27,0,0,0-.23-.12H84.92a.29.29,0,0,0-.26.16,3.35,3.35,0,0,1-3.27,1.93A3.79,3.79,0,0,1,77.46,20H88.55a.28.28,0,0,0,.28-.24A9.33,9.33,0,0,0,89,18.18,7.27,7.27,0,0,0,81.39,10.54Zm-.13,3.18a3.61,3.61,0,0,1,3.87,3.19H77.5A3.74,3.74,0,0,1,81.26,13.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97.65,17.05c-1.94-.54-3.12-.94-3.12-1.94s.81-1.39,2.23-1.39,2.41.72,2.51,1.93a.29.29,0,0,0,.29.27h3.09a.33.33,0,0,0,.21-.09.29.29,0,0,0,.07-.22c-.17-3.12-2.49-5.07-6.06-5.07s-6,1.94-6,4.6c0,3.39,3.08,4.21,5.55,4.87,1.68.45,3.12.84,3.12,1.86s-.94,1.5-2.45,1.5a2.46,2.46,0,0,1-2.69-2,.3.3,0,0,0-.29-.27h-3.2a.33.33,0,0,0-.21.09.35.35,0,0,0-.08.22c.15,2.95,2.89,5.09,6.53,5.09s6-1.93,6-4.71C103,18.53,100,17.71,97.65,17.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.41,10.79h-3.35V7.36a.28.28,0,0,0-.28-.29h-3.12a.29.29,0,0,0-.29.29v3.43H104.9a.29.29,0,0,0-.29.29V13.6a.28.28,0,0,0,.29.28h1.47v8c0,2.94,1.55,4.43,4.6,4.43h2.44a.29.29,0,0,0,.29-.29V23.44a.29.29,0,0,0-.29-.29h-1.9c-1.23,0-1.45-.41-1.45-1.28v-8h3.35a.28.28,0,0,0,.29-.28V11.08A.29.29,0,0,0,113.41,10.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 115.97,
    y: 10.79,
    width: 3.67,
    height: 15.51,
    rx: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.83,4.85a2.27,2.27,0,1,0,2.24,2.27A2.25,2.25,0,0,0,117.83,4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M137.73,10.79h-3.12a.29.29,0,0,0-.29.29v1.38a6.82,6.82,0,0,0-4.89-1.92c-4.25,0-7.34,3.34-7.34,7.94s3.16,8.06,7.34,8.06a6.79,6.79,0,0,0,4.89-2v1.72c0,2.6-1.45,4.16-3.89,4.16-2,0-3.54-1-4-2.4a.29.29,0,0,0-.27-.21h-3.07a.28.28,0,0,0-.21.1.29.29,0,0,0-.07.22c.39,3.37,3.37,5.54,7.6,5.54,4.61,0,7.58-2.91,7.58-7.41V11.08A.28.28,0,0,0,137.73,10.79Zm-7.65,12.5c-2.75,0-4.24-2.48-4.24-4.81s1.46-4.68,4.24-4.68c2.11,0,4.24,1.63,4.24,4.73S132.19,23.29,130.08,23.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 141.51,
    y: 10.79,
    width: 3.67,
    height: 15.51,
    rx: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M143.37,4.85a2.27,2.27,0,1,0,0,4.53,2.22,2.22,0,0,0,2.23-2.26A2.23,2.23,0,0,0,143.37,4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M155.56,10.54a7.68,7.68,0,0,0-7.9,8c0,4.72,3.19,8,7.77,8a7.76,7.76,0,0,0,8-8A7.69,7.69,0,0,0,155.56,10.54Zm-.13,12.75c-2.46,0-4.05-1.87-4.05-4.76,0-3.49,2.22-4.73,4.13-4.73,2.1,0,4.21,1.46,4.21,4.73C159.72,20.82,158.38,23.29,155.43,23.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M50.64,32.76H49.23V29a.07.07,0,0,0-.07-.07h-.72a.07.07,0,0,0-.07.07v4.38a.07.07,0,0,0,.07.07h2.2a.07.07,0,0,0,.07-.07v-.58A.07.07,0,0,0,50.64,32.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 51.17,
    y: 29.86,
    width: 0.87,
    height: 3.62,
    rx: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51.6,28.48a.53.53,0,0,0-.53.54.53.53,0,1,0,1.06,0A.53.53,0,0,0,51.6,28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56.23,28.67H55.5a.08.08,0,0,0-.07.08v1.49a1.75,1.75,0,0,0-1.12-.43,1.73,1.73,0,0,0-1.72,1.85,1.77,1.77,0,0,0,1.71,1.88,1.59,1.59,0,0,0,1.13-.45v.32a.07.07,0,0,0,.07.07h.73a.07.07,0,0,0,.07-.07V28.75A.08.08,0,0,0,56.23,28.67Zm-1.78,4.1a1,1,0,0,1-1-1.11,1,1,0,1,1,1,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.67,29.81a1.74,1.74,0,0,0-1.81,1.86,1.76,1.76,0,0,0,1.81,1.87,1.67,1.67,0,0,0,1.66-1.14.09.09,0,0,0,0-.07.06.06,0,0,0-.06,0h-.77a.08.08,0,0,0-.07,0,.77.77,0,0,1-.75.45.88.88,0,0,1-.91-.78h2.57s.07,0,.07-.06a2,2,0,0,0,0-.36A1.69,1.69,0,0,0,58.67,29.81Zm0,.75a.83.83,0,0,1,.89.73H57.77A.87.87,0,0,1,58.64,30.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M62.82,29.81a1.24,1.24,0,0,0-1,.4v-.27a.08.08,0,0,0-.07-.08h-.72a.08.08,0,0,0-.07.08v3.47a.07.07,0,0,0,.07.07h.72a.07.07,0,0,0,.07-.07V31.58c0-.63.23-.88.79-.88h.18a.08.08,0,0,0,.07-.08v-.74A.07.07,0,0,0,62.82,29.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M66.81,29.86h-.73a.08.08,0,0,0-.07.08v.31a1.55,1.55,0,0,0-1.13-.44,1.73,1.73,0,0,0-1.71,1.85,1.76,1.76,0,0,0,1.7,1.88A1.65,1.65,0,0,0,66,33.09v.32a.07.07,0,0,0,.07.07h.73a.07.07,0,0,0,.07-.07V29.94A.08.08,0,0,0,66.81,29.86ZM65,32.77a1,1,0,0,1-1-1.11,1,1,0,1,1,1,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69.51,29.81a1.42,1.42,0,0,0-1,.34v-.21a.09.09,0,0,0-.08-.08h-.72a.08.08,0,0,0-.07.08v3.47a.07.07,0,0,0,.07.07h.72a.08.08,0,0,0,.08-.07V31.47c0-.57.29-.89.8-.89s.79.32.79.89v1.94a.08.08,0,0,0,.08.07h.71a.07.07,0,0,0,.07-.07v-2A1.42,1.42,0,0,0,69.51,29.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.17,28.67h-.72a.09.09,0,0,0-.08.08v1.49a1.71,1.71,0,0,0-2.84,1.42,1.77,1.77,0,0,0,1.71,1.88,1.57,1.57,0,0,0,1.13-.45v.32a.08.08,0,0,0,.08.07h.72a.07.07,0,0,0,.07-.07V28.75A.08.08,0,0,0,75.17,28.67Zm-1.78,4.1a1,1,0,0,1-1-1.11,1,1,0,1,1,2,0A1,1,0,0,1,73.39,32.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.65,29.81a1.79,1.79,0,0,0-1.84,1.86,1.76,1.76,0,0,0,1.81,1.87,1.82,1.82,0,0,0,1.88-1.87A1.79,1.79,0,0,0,77.65,29.81Zm0,3c-.57,0-.93-.43-.93-1.1a1,1,0,0,1,1-1.09,1,1,0,0,1,1,1.09A1,1,0,0,1,77.62,32.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.14,28.67H84.7a.09.09,0,0,0-.08.08v1.7a1.61,1.61,0,0,0-1.28-.61,1.85,1.85,0,0,0,0,3.69,1.52,1.52,0,0,0,1.28-.62v.5a.08.08,0,0,0,.08.07h.44a.07.07,0,0,0,.07-.07V28.75A.08.08,0,0,0,85.14,28.67Zm-.52,3a1.21,1.21,0,1,1-2.41,0,1.18,1.18,0,0,1,1.21-1.3A1.2,1.2,0,0,1,84.62,31.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M87.63,29.84a1.85,1.85,0,0,0,0,3.69,1.59,1.59,0,0,0,1.65-1.19.08.08,0,0,0,0-.07l-.06,0h-.47a.08.08,0,0,0-.07,0,1,1,0,0,1-1,.71,1.11,1.11,0,0,1-1.16-1.08h2.78a.07.07,0,0,0,.07-.06c0-.13,0-.22,0-.36A1.63,1.63,0,0,0,87.63,29.84Zm0,.53a1.13,1.13,0,0,1,.83.32,1.1,1.1,0,0,1,.29.74H86.47A1.12,1.12,0,0,1,87.62,30.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.33,31.46c-.46-.12-.86-.24-.86-.62s.28-.47.67-.47.74.23.76.61A.09.09,0,0,0,92,31h.44s0,0,0,0a.08.08,0,0,0,0-.05,1.19,1.19,0,0,0-1.33-1.13,1.16,1.16,0,0,0-1.29,1c0,.77.7.95,1.25,1.1s.82.22.82.54-.28.52-.69.52-.82-.22-.86-.58a.07.07,0,0,0-.07-.07h-.45a.09.09,0,0,0-.06,0,.08.08,0,0,0,0,0c.06.67.64,1.09,1.46,1.09s1.27-.43,1.27-1S91.89,31.62,91.33,31.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.53,28.67h-.45a.08.08,0,0,0-.07.08v1.7a1.61,1.61,0,0,0-1.28-.61,1.85,1.85,0,0,0,0,3.69A1.56,1.56,0,0,0,96,32.91v.5a.07.07,0,0,0,.07.07h.45a.07.07,0,0,0,.07-.07V28.75A.08.08,0,0,0,96.53,28.67Zm-.52,3a1.21,1.21,0,1,1-2.41,0,1.18,1.18,0,0,1,1.21-1.3A1.2,1.2,0,0,1,96,31.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99,29.84a1.85,1.85,0,0,0,0,3.69,1.59,1.59,0,0,0,1.65-1.19.08.08,0,0,0,0-.07l-.05,0h-.47a.08.08,0,0,0-.07,0A1,1,0,0,1,99,33a1.11,1.11,0,0,1-1.16-1.08h2.77a.09.09,0,0,0,.08-.06c0-.13,0-.22,0-.36A1.63,1.63,0,0,0,99,29.84Zm0,.53a1.14,1.14,0,0,1,.84.32,1.1,1.1,0,0,1,.29.74H97.86A1.1,1.1,0,0,1,99,30.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.67,29.84a1.85,1.85,0,0,0,0,3.69,1.59,1.59,0,0,0,1.64-1.19.08.08,0,0,0,0-.07l-.06,0h-.46s-.07,0-.07,0a1,1,0,0,1-1,.71,1.13,1.13,0,0,1-1.17-1.08h2.78a.07.07,0,0,0,.07-.06,2.11,2.11,0,0,0,0-.36A1.64,1.64,0,0,0,104.67,29.84Zm0,.53a1.17,1.17,0,0,1,.84.32,1.09,1.09,0,0,1,.28.74h-2.26A1.1,1.1,0,0,1,104.65,30.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 107.03,
    y: 28.67,
    width: 0.59,
    height: 4.81,
    rx: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.62,31.32c-.38-.11-.72-.2-.72-.44s.19-.32.52-.32.55.16.57.44a.08.08,0,0,0,.08.07h.71l.06,0a.14.14,0,0,0,0-.06,1.26,1.26,0,0,0-1.42-1.18c-.82,0-1.41.45-1.41,1.07,0,.79.72,1,1.3,1.14.38.1.72.19.72.42s-.22.35-.56.35a.56.56,0,0,1-.62-.45.08.08,0,0,0-.08-.07h-.74l0,0s0,0,0,.06a1.37,1.37,0,0,0,1.52,1.19c.82,0,1.4-.45,1.4-1.1S112.18,31.47,111.62,31.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.1,29.81a1.74,1.74,0,0,0-1.81,1.86,1.76,1.76,0,0,0,1.81,1.87,1.67,1.67,0,0,0,1.66-1.14.09.09,0,0,0,0-.07.07.07,0,0,0-.06,0h-.77a.08.08,0,0,0-.07,0,.77.77,0,0,1-.75.45.87.87,0,0,1-.91-.78h2.57s.07,0,.07-.06a2,2,0,0,0,0-.36A1.7,1.7,0,0,0,115.1,29.81Zm0,.75a.84.84,0,0,1,.9.73H114.2A.86.86,0,0,1,115.06,30.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.25,29.81a1.24,1.24,0,0,0-1,.4v-.27a.08.08,0,0,0-.07-.08h-.72a.08.08,0,0,0-.07.08v3.47a.07.07,0,0,0,.07.07h.72a.07.07,0,0,0,.07-.07V31.58c0-.63.23-.88.79-.88h.18a.08.08,0,0,0,.07-.08v-.74A.07.07,0,0,0,119.25,29.81Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoleft);
export default __webpack_public_path__ + "static/media/logoleft.47bb86930a75663836067484ab7c8565.svg";
export { ForwardRef as ReactComponent };